var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-title"},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"left"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }